export const ENDPOINTS = {
    TENDER: {

        TENDER_SUMMARY_BY_KEYWORD: "tender/tender-summary-by-keyword",
        TENDER_SUMMARY_BY_CATEGORY: "tender/tender-summary-by-category",
        TENDER_SUMMARY_BY_AUTHORITY: "tender/tender-summary-by-authority",
        TENDER_SUMMARY_BY_STATE: "tender/tender-summary-by-state",
        RETRIEVE_TENDER_BY_CITIES: "tender/tender-summary-by-city",
        TENDER_SUMMARY_BY_PROCUREMENT: "tender/tender-summary-by-procurement",

        TENDER_STATS: "tender/tenderStats",
        SEARCH: "tender/auto-suggest",
        TENDER_KEYWORDS: "tender/all-tenders/indexing",

        RETRIEVE_TENDERS_LISTING: "tender/listing",
        RETRIEVE_TENDER_DETAILS: "tender/details/",
        NEWLY_ADDED_TENDERS: "tender/new/added-in-last-3-days",

        RETRIEVE_TRENDING: "tender/trending",
        GUESTIDENTIFY: "v1/guest/identify",
        CSV_EXPORT: "tender/listing-page/export",

        CMS: {
            CONTACT_US: "cms/contactUs",
            RETRIEVE_STATE_LIST: "cms/stateList",
            RETRIEVE_CITY_LIST: "cms/cityList",
            DOWNLOAD_DOC: "cms/download",
            RETRIEVE_SEO_DETAILS: "cms/fetch/seo-content",
            RETRIEVE_KEYWORDS_LIST: "cms/keywordList",
            RETRIEVE_AUTHORITY_LIST: "cms/authorityList",
            RETRIEVE_PROCUREMENT_LIST: "cms/procurementList",
            RETRIEVE_CATEGORY_LIST: "cms/categoryList",
            FAQLIST: 'cms/faqsList',
            SUBSCRIBE_TENDER: 'cms/subscribe/tender',
            BLOG_LIST: 'cms/blogs',
            USER_INTEREST: 'cms/interest',
            TRENDING_SEARCH: "cms/trendingSearch",
            SET_PREFERENCES: "cms/preferences",
            APP_DOWNLOAD: "cms/app-download",
            INTEREST_PLAN: 'cms/interested-plan',
            PLANINTEREST: "cms/subscription/plan-selection",
        },

        OTP: {
            OTP_SEND: "otp/send",
            OTP_SIGNUP: "otp/signup",
            OPT_VERIFY: "otp/verify",
        },

        BLOG: {
            BLOG_Details: "wp-json/wp/v2/posts",
        },
    },
};